import { render, staticRenderFns } from "./processDetails.vue?vue&type=template&id=0fdf051e&scoped=true"
import script from "./processDetails.vue?vue&type=script&lang=js"
export * from "./processDetails.vue?vue&type=script&lang=js"
import style0 from "./processDetails.vue?vue&type=style&index=0&id=0fdf051e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fdf051e",
  null
  
)

export default component.exports